/**
 * Created by Klayer3
 */

import * as Rx from 'rxjs/Rx';
import {Service} from './Service';
import {DTO, Entity} from '../entities/entities';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';
import {Response} from '@angular/http';
import {TableFilter} from '../TableConfig';
import {ErrorService, ErrorType} from './error.service';
import {ResolverService} from './resolver.service';
import {isFunction} from 'util';
import * as _ from 'lodash';

export abstract class ServiceBase<T extends Entity> implements Service<T> {

  // FIXME K3 passare da metodo?
  protected _filterObject: TableFilter = new TableFilter(['id']);
  private _subject: BehaviorSubject<T[]> = new BehaviorSubject<T[]>([]);
  public readonly dataChange: Rx.Observable<T[]> = this._subject.asObservable();
  private _errorService: ErrorService = ResolverService.instance().getService('ErrorService');
  private _data: T[] = [];

  get spinnerService(){
    return ResolverService.instance().spinnerService;
  }

  public abstract getCleanInstance(): T;

  abstract add(entity: T): Rx.Observable<T>;

  abstract update(entity: T): Rx.Observable<T>;

  abstract remove(entity: T): Rx.Observable<T> ;

  abstract loadItems(options?: any): Rx.Observable<T[]> ;

  abstract load(entity: T, force?: boolean, add?: boolean): Rx.Observable<T> ;

  public getError(dto: any) {
    const body = dto;

    if (!body || !body.success) {
      if (body) {

        const newCoreError: boolean = body.error && body.path && body.status;
        if ( newCoreError) {
          const error = new Error();
          error.name = body.status;
          error.message = body.message;
          return error;
        }else {
          const error = new Error();
          error.name = body.errorCode;
          error.message = body.errorMessage;
          return error;
        }
      }
    }

    return null;
  }

  public handleError(error: any, type?: ErrorType) {

    if( error instanceof Response) {
      if (error && error.json && isFunction(error.json) && error.json()) {
        const body: DTO = <DTO> error.json();
        const err = this.getError(body);
        if (err) {
          error = err;
        }
      }else {
        error = {
          name: error.status,
          message: error.status
        };
      }
    }

    this._errorService.push(error, type);
    // Observable.throw(error);
    return error;
  }

  public filterItems(filter: any, filterObject?: TableFilter): Rx.Observable<T[]> {
    filterObject = filterObject || this._filterObject;
    return Rx.Observable.from([filterObject.listFilter(this.data, filter)]);
  }

  getData(): T[] {
    return this.data;
  }

  public get data(): T[] {
    return <T[]>this._subject.getValue().slice();
  }

  protected onDataChange() {
    this._subject.next(this.data);
  }

  protected init() {
  }

  protected getIndex(entity: T) {

    for (let i = 0; i < this.data.length; i++) {
      // voluto == e non  ===
      if (this.data[i].id == entity.id) {
        return i;
      }
    }

    return -1;
  }

  protected onAddOrUpdate(data): T {
    const me = this;
    const ret = me.fromJson(data);
    if (ret) {
      const index = me.getIndex(ret);
      if (index !== -1) {
        me._subject.getValue()[index] = ret;
      } else {
        me._subject.getValue().push(ret);
      }
      me.onDataChange();
    }
    return ret;
  }

  public fromJsonArray(jsonArray: any[]): T[] {
    const me = this;
    let ret: T[] = [];

    if (jsonArray) {
      ret = jsonArray.map(item => me.fromJson(item));
    }
    return ret;
  }

  protected setItems(data: any[]): T[] {
    const me = this;
    me._subject.next(me.fromJsonArray(data));
    me.onDataChange();
    return me.data;
  }

  protected onRemove(data: T) {
    const me = this;
    const index = me.getIndex(data);
    if (index !== -1) {
      me._subject.getValue().splice(index, 1);
      me.onDataChange();
    }
  }

  loadById(id: any, force?: boolean, add?: boolean): Rx.Observable<T> {
    return this.load(<T> {id: id}, force, add);
  }

  public fromEntity(en: T): any {
    const json = en; // JSON.parse(JSON.stringify(en));
    return json;
  }

  public fromJson(json): T {
    if (json) {
      return Object.assign(this.getCleanInstance(), json);
    }
    return null;
  }

  public clone(json): T {
    // il clone dovrebbe andare a clonare effettivamente l'oggetto JSON.parse(JSON.stringify(en)); ma ci da problemi...
    return this.fromJson(this.fromEntity(_.cloneDeep(json)));
  }


}



// WEBPACK FOOTER //
// ./src/app/core/services/ServiceBase.ts